import { useStore } from '../../store'
import { cn } from '../../lib/utils'
import { TickerTape } from './TickerTape'

export function Topbar() {
  const eodhd = useStore((s) => s.health?.eodhd)

  return (
    <header className="hidden h-12 shrink-0 items-center gap-3 border-b border-[var(--line-soft)] bg-[var(--color-void)] px-3 md:flex">
      <div className="flex shrink-0 items-center gap-2">
        <span className="orb-mini" style={{ width: 18, height: 18 }} aria-hidden />
        <span className="text-[13px] font-semibold tracking-[0.16em] text-fg">LIBERABANK</span>
      </div>
      <div className="mx-1 hidden h-5 w-px bg-[var(--line-soft)] sm:block" />
      <div className="hidden min-w-0 flex-1 sm:flex">
        <TickerTape />
      </div>
      <div className="flex shrink-0 items-center gap-1.5 text-[11px] text-fg-subtle">
        <span className={cn('h-1.5 w-1.5 rounded-full', eodhd ? 'bg-up' : 'bg-flat')} />
        {eodhd ? 'Live data' : 'Offline'}
      </div>
    </header>
  )
}
